import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { createSelectors } from '~/shared/lib/zustand-utils'
import { EOB_ONBOARDING_STORAGE_KEY } from '../config'

interface EobOnboardingPersistedStore {
  hasSeenPatientClaimOnboarding: boolean
  markPatientClaimOnboardingSeen: () => void
  hasSeenSummaryReviewedOnboarding: boolean
  markSummaryReviewedOnboardingSeen: () => void
}

const eobOnboardingPersistedStore = createSelectors(
  create<EobOnboardingPersistedStore>()(
    persist(
      (set) => ({
        hasSeenPatientClaimOnboarding: false,
        markPatientClaimOnboardingSeen: () => set({ hasSeenPatientClaimOnboarding: true }),
        hasSeenSummaryReviewedOnboarding: false,
        markSummaryReviewedOnboardingSeen: () => set({ hasSeenSummaryReviewedOnboarding: true }),
      }),
      { name: EOB_ONBOARDING_STORAGE_KEY },
    ),
  ),
)

interface EobOnboardingTransientStore {
  isPatientClaimOnboardingOpen: boolean
  setIsPatientClaimOnboardingOpen: (open: boolean) => void
  isSummaryReviewedOnboardingOpen: boolean
  setIsSummaryReviewedOnboardingOpen: (open: boolean) => void
}

const eobOnboardingTransientStore = createSelectors(
  create<EobOnboardingTransientStore>((set) => ({
    isPatientClaimOnboardingOpen: false,
    setIsPatientClaimOnboardingOpen: (open: boolean) => set({ isPatientClaimOnboardingOpen: open }),
    isSummaryReviewedOnboardingOpen: false,
    setIsSummaryReviewedOnboardingOpen: (open: boolean) =>
      set({ isSummaryReviewedOnboardingOpen: open }),
  })),
)

export const useEobOnboardingSelectors = () => {
  const hasSeenPatientClaimOnboarding =
    eobOnboardingPersistedStore.use.hasSeenPatientClaimOnboarding()
  const markPatientClaimOnboardingSeen =
    eobOnboardingPersistedStore.use.markPatientClaimOnboardingSeen()
  const isPatientClaimOnboardingOpen =
    eobOnboardingTransientStore.use.isPatientClaimOnboardingOpen()
  const setIsPatientClaimOnboardingOpen =
    eobOnboardingTransientStore.use.setIsPatientClaimOnboardingOpen()
  const hasSeenSummaryReviewedOnboarding =
    eobOnboardingPersistedStore.use.hasSeenSummaryReviewedOnboarding()
  const markSummaryReviewedOnboardingSeen =
    eobOnboardingPersistedStore.use.markSummaryReviewedOnboardingSeen()
  const isSummaryReviewedOnboardingOpen =
    eobOnboardingTransientStore.use.isSummaryReviewedOnboardingOpen()
  const setIsSummaryReviewedOnboardingOpen =
    eobOnboardingTransientStore.use.setIsSummaryReviewedOnboardingOpen()
  return {
    hasSeenPatientClaimOnboarding,
    markPatientClaimOnboardingSeen,
    isPatientClaimOnboardingOpen,
    setIsPatientClaimOnboardingOpen,
    hasSeenSummaryReviewedOnboarding,
    markSummaryReviewedOnboardingSeen,
    isSummaryReviewedOnboardingOpen,
    setIsSummaryReviewedOnboardingOpen,
  }
}
